
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import store from "@/state/store";
var state = store._modules.root._children.auth.state;
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      InventoryLogs: [],
      page: 1,
      limit: 20,
      DeliveryMen: [],
      inventory_id: null,
      tot_pages: 0,
      total_weight: null,
      searchInventoryLogs: null,
      InventoryLogsSearchMode: false,
      searchModel: "",
      state: state,
    };
  },
  methods: {
    getDeliveryMen() {
      this.http.get("delivery-men").then((res) => {
        this.DeliveryMen = res.data;
      });
    },
    addInventoryLogs() {
      console.log("**********####", this.state);
      var data = {
        title: "popups.addInventoryLogs",
        inputs: [
          {
            model: "driver_id",
            type: "select",
            options: (() => {
              return this.DeliveryMen.map((data) => {
                return {
                  value: data.id,
                  label: data?.full_name,
                };
              });
            })(),
            label: "inventory_logs.driver_id",
          },
          {
            model: "total_weight",
            type: "number",
            label: "inventory_logs.total_weight",
          },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              obj.inventory_id = this.inventory_id;
              this.http.post("inventory-logs", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editInventoryLogs(app) {
      var data = {
        title: "popups.inventory_logs",
        inputs: [
          {
            model: "driver_id",
            type: "select",
            options: (() => {
              return this.DeliveryMen.map((data) => {
                return {
                  value: data.id,
                  label:data?.full_name,
                };
              });
            })(),
            label: "inventory_logs.driver_id",
          },
          {
            model: "total_weight",
            type: "text",
            label: "inventory_logs.total_weight",
            value: app.total_weight,
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("inventory-logs", app.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    updateInventoryLogs(app) {
      var data = {
        title: "popups.editfile",
        inputs: [
          {
            model: "driver_id",
            type: "text",
            label: "inventory_logs.driver_id",
          },
          {
            model: "total_weight",
            type: "text",
            label: "inventory_logs.total_weight",
          },
          {
            model: "createdAt",
            type: "text",
            label: "inventory_logs.createdAt",
          },
          {
            model: "updatedAt",
            type: "text",
            label: "inventory_logs.updatedAt",
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              obj.emp_id = app.id;
              this.http.do("inventory-logs", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    search() {
      this.InventoryLogsSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("inventory-logs/search", {
          search: this.searchModel,
          limit: this.limit,
          page: this.page,
          col: "",
        })
        .then((res) => {
          this.InventoryLogs = res.data;
          console.log("######## files", this.InventoryLogs);
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.InventoryLogsSearchMode = false;
      this.get(this.page);
    },

    getInventoryLogs() {
      this.http.get("inventory-logs").then((res) => {
        this.InventoryLogs = res.data;
      });
    },
    deleteInventoryLogs(app) {
      var data = {
        title: "popups.deletefile",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          console.log("###");
          this.http.delete("inventory-logs", app.id).then(() => {
            console.log("############################3");
            this.get(this.page);
          });
        }
      });
    },

    get(page) {
      console.log(page);
      this.http
        .post("inventory-logs/paginate", {
          limit: this.limit,
          inventory_id: this.inventory_id,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.InventoryLogs = res.data;
          this.InventoryLogs.forEach((item) => {
            this.total_weight += item?.total_weight;
          });
        });
    },
  },
  created() {
    this.inventory_id = this.$route.params.id;
    this.get(1);
    this.getDeliveryMen();
    // this.getInventoryLogs();
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.inventory_logs.text')"
    />
    <div class="row">
      <div class="col-6">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @keyup="search()"
              type="text"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <button
          class="btn-close text-light"
          v-if="InventoryLogsSearchMode"
          @click="cancelappsearchMode()"
        ></button>
        <button
          type="button"
          @click="addInventoryLogs()"
          class="btn btn-light float-end mb-4"
        >
          <span
            class="bx bxs-plus-circle float-end fa-2x"
            style="color: #2a3042 !important"
          ></span>
        </button>
      </div>
    </div>

    <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
      <thead>
        <tr
          class="text-light text-center"
          style="background-color: #2a3042 !important"
        >
          <th scope="col">{{ $t("inventory_logs.id") }}</th>
          <th scope="col">{{ $t("inventory_logs.driver_id") }}</th>
          <th scope="col">{{ $t("inventory_logs.total_weight") }}</th>
          <!-- <th scope="col">{{ $t("inventory_logs.createdAt") }}</th>
          <th scope="col">{{ $t("inventory_logs.updatedAt") }}</th> -->
          <th scope="col">{{ $t("inventory_logs.operations") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="app in InventoryLogs" :key="app" class="text-center">
          <td>{{ app.driver_id }}</td>
          <td>-----</td>
          <td>{{ app.total_weight }}</td>
          <!-- <td>{{ app.createdAt }}</td>
          <td>{{ app.updatedAt }}</td> -->

          <td colspan="2">
            <a
              class="btn btn-primary mx-1"
              @click="editInventoryLogs(app)"
              href="javascript: void(0);"
              role="button"
              >{{ $t("popups.edit") }}</a
            >
            <a
              class="btn btn-danger"
              href="javascript: void(0);"
              role="button"
              @click="deleteInventoryLogs(app)"
              >{{ $t("popups.delete") }}</a
            >
          </td>
        </tr>
      </tbody>

      <tbody>
        <tr>
          <th colspan=""></th>
          <th colspan="2"></th>
          <th colspan="1">Total of weight /{{ total_weight }}</th>
        </tr>
      </tbody>
    </table>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <div v-if="tot_pages == 20">
      <!--   Apps  paginate     -->
      <ul class="paginate paginate-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
            p
          }}</a>
        </li>

        <li class="page-item" :class="{ disabled: page == total_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
    <!--end-->
  </Layout>
</template>

<style scoped>
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>




